import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/gold/goldExplain/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/gold/goldExplain',
    exact: true,
    meta: {
      title: '金币说明'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/gold/goldDetail/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/gold/goldDetail',
    meta: {
      title: '我的金币'
    }
  }
]
